
<div :class="wrapperClass" role="alert">
  <row class="mb-0">
    <prefix v-if="$slots.prefix">
      <slot name="prefix"></slot>
    </prefix>
    <slot name="message">
      <column class="p-sm" :class="{'font-weight-normal': !bold}">
        <slot>
          <ul>
            <li v-for="(m, ind) in fullMessages" :ref="`message-${ind}`" v-html="m"></li>
          </ul>
        </slot>
      </column>
    </slot>
    <suffix v-if="dismissable" type="button" class="btn-icon grey-to-red close" data-dismiss="alert">
      <span class="sr-only">Dismiss Alert Button</span>
      <icon class="times"></icon>
    </suffix>
  </row>
</div>
